import { roomBrowseList } from './room-browse-list'
import {
  CREATE_ROOM_SUCCESS,
  DELETE_ROOM_SUCCESS,
  UPDATE_ROOM_SUCCESS,
  FILTER_ROOMS,
  LOAD_ROOMS_SUCCESS,
  SELECT_BUILDING,
  UNLOAD_ROOMS_SUCCESS
} from './action-types'

export function createRoomSuccess(room) {
  return {
    type: CREATE_ROOM_SUCCESS,
    payload: room
  };
}

export function deleteRoomSuccess(room) {
  return {
    type: DELETE_ROOM_SUCCESS,
    payload: room
  };
}

export function updateRoomSuccess(room) {
  return {
    type: UPDATE_ROOM_SUCCESS,
    payload: room
  };
}

export function loadRoomsSuccess(rooms) {
  return {
    type: LOAD_ROOMS_SUCCESS,
    payload: rooms
  };
}

export function filterRooms(filterType) {
  return {
    type: FILTER_ROOMS,
    payload: {filterType}
  };
}

export function loadRooms(building) {
  return (dispatch, getState) => {
    roomBrowseList.path = `rooms-rhodes`;
    const lookUp = {
      queryChild: 'building',
      queryString: building,
      lookUpType: "equalTo"
    }
    roomBrowseList.subscribe(dispatch, lookUp);
  };
}

export function unloadRooms() {
  roomBrowseList.unsubscribe();
  return {
    type: UNLOAD_ROOMS_SUCCESS
  };
}

export function selectBuilding(building) {
  return {
    type: SELECT_BUILDING,
    payload: building
  }
}


// WEBPACK FOOTER //
// ./src/core/room-browse/actions.js